import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { fixGridAndFilterBuilder } from 'react/utils/utils';
import * as Cruds from 'react/containers/cruds';

class CrudTab extends PureComponent {
  activeClassName = 'is-active';

  constructor(props) {
    super(props);
    const { tab: { key: entity }, updateTitle } = props;
    const [, , parentId] = this.getParametersFromPathName();
    const EntityRouter = App.Routers[entity];
    
    if (EntityRouter) {
      const router = new EntityRouter();
      if (Cruds[entity]) {
        router.tabSelector = `${entity}Grid`;
      }
      if (parentId) {
        router.parentId = parentId;
      }
      router.updateTabTitle = (layout) => {
        updateTitle({
          key: entity,
          title: Monet.I18n.getResourcesByKey(layout.userInterfaceAction.userInterface.description)
        });
      };
      App.Objects[entity] = router;
      this.router = App.Objects[entity];
    }
  }

  componentDidMount() {
    this.goToCrudMethod();
  }

  componentDidUpdate(prevProps) {
    const { active, tab: { pathname } } = this.props;
    const isComingFromAnotherTab = active !== prevProps.active;
    const didChangeTab = pathname !== prevProps.tab.pathname;
    const forceUpdate = isComingFromAnotherTab && didChangeTab;

    if (isComingFromAnotherTab && active) {
      fixGridAndFilterBuilder();
    }

    if ((!isComingFromAnotherTab && active && didChangeTab && this) || forceUpdate) {
      this.goToCrudMethod();
    }
  }

  getParametersFromPathName() {
    const { tab: { extra, pathname } } = this.props;
    const parentId = extra ? extra.parentId : null;
    const { length } = pathname.split('/');
    const index = (length - 2) + (length % 2);
    const [mode, id] = pathname.split('/').slice(index);
    return [mode, id, parentId];
  }

  goToCrudMethod = () => {
    const { tab: { key: entity } } = this.props;
    const [mode, id] = this.getParametersFromPathName();
    if (!Cruds[entity]) {
      switch (mode) {
        case 'edit':
          this.router.edit(id);
          break;
        case 'new':
          this.router.form_new();
          break;
        default:
          this.router.list();
          break;
      }
    }
  };

  renderCrud = () => {
    const { tab: { key: entity }, updateTitle } = this.props;
    const [mode, id] = this.getParametersFromPathName();
    const Crud = Cruds[entity];
    return Crud ? (
      <Crud entity={entity} id={id} isGrid={!mode} updateTitle={updateTitle} />
    ) : null;
  }

  render() {
    const { tab: { key: entity }, active } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;
    return (
      <div className={className}>
        <div id={entity}>
          {this.renderCrud()}
        </div>
      </div>
    );
  }
}

CrudTab.propTypes = {
  active: PropTypes.bool,
  tab: PropTypes.object.isRequired,
  updateTitle: PropTypes.func.isRequired
};

CrudTab.defaultProps = {
  active: false
};

export default CrudTab;
